let currentAudio = null;
let currentButton = null;
let globalAudioActive = false;

// Create a fixed container for the global audio player
function createGlobalAudioContainer() {
    if (!document.getElementById('global-audio-container')) {
        const container = document.createElement('div');
        container.id = 'global-audio-container';
        container.className = 'global-audio-player';
        container.innerHTML = `
            <div class="player-controls">
                <button id="global-audio-toggle" class="player-button">
                    <i class="fa fa-pause"></i>
                </button>
                <div class="player-info">
                    <span id="global-audio-title">Now playing...</span>
                </div>
                <button id="global-audio-close" class="player-button">
                    <i class="fa fa-times"></i>
                </button>
            </div>
        `;
        document.body.appendChild(container);
        
        // Add event listeners
        document.getElementById('global-audio-toggle').addEventListener('click', toggleGlobalAudio);
        document.getElementById('global-audio-close').addEventListener('click', stopAllAudio);
        
        // Hide initially
        container.style.display = 'none';
    }
}

function toggleGlobalAudio() {
    if (currentAudio) {
        if (currentAudio.paused) {
            currentAudio.play();
            document.getElementById('global-audio-toggle').innerHTML = '<i class="fa fa-pause"></i>';
        } else {
            currentAudio.pause();
            document.getElementById('global-audio-toggle').innerHTML = '<i class="fa fa-play"></i>';
        }
    }
}

export function playHotspotAudio(audioPath, button, title = "") {
    // Initialize the global audio container if it doesn't exist
    createGlobalAudioContainer();
    
    // If button is provided, update UI based on audio state
    if (button) {
        // If current audio is already playing this file
        if (currentAudio && currentAudio.src.endsWith(audioPath)) {
            if (!currentAudio.paused) {
                // Pause if playing
                currentAudio.pause();
                button.innerHTML = '<i class="fa fa-play"></i>';
                button.classList.remove('playing');
                document.getElementById('global-audio-toggle').innerHTML = '<i class="fa fa-play"></i>';
            } else {
                // Resume if paused
                currentAudio.play()
                    .then(() => {
                        button.innerHTML = '<i class="fa fa-pause"></i>';
                        button.classList.add('playing');
                        document.getElementById('global-audio-toggle').innerHTML = '<i class="fa fa-pause"></i>';
                    })
                    .catch(error => {
                        console.error('Error playing audio:', error);
                        button.innerHTML = '<i class="fa fa-exclamation-triangle"></i>';
                    });
            }
        } else {
            // Different audio or no audio playing
            
            // First, reset UI of previous button if exists
            if (currentButton && currentButton !== button) {
                currentButton.innerHTML = '<i class="fa fa-play"></i>';
                currentButton.classList.remove('playing');
            }
            
            // Stop previous audio if exists
            if (currentAudio) {
                currentAudio.pause();
                currentAudio.currentTime = 0;
            }
            
            // Create and play new audio
            currentAudio = new Audio(audioPath);
            currentButton = button;
            
            // Change button to loading state
            button.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
            
            // Show the global audio player
            const container = document.getElementById('global-audio-container');
            container.style.display = 'block';
            document.getElementById('global-audio-title').textContent = title || 'Playing audio...';
            
            currentAudio.play()
                .then(() => {
                    button.innerHTML = '<i class="fa fa-pause"></i>';
                    button.classList.add('playing');
                    document.getElementById('global-audio-toggle').innerHTML = '<i class="fa fa-pause"></i>';
                    globalAudioActive = true;
                })
                .catch(error => {
                    console.error('Error playing audio:', error);
                    button.innerHTML = '<i class="fa fa-exclamation-triangle"></i>';
                });
                
            // When audio ends, reset button and hide global player
            currentAudio.addEventListener('ended', () => {
                button.innerHTML = '<i class="fa fa-play"></i>';
                button.classList.remove('playing');
                document.getElementById('global-audio-container').style.display = 'none';
                globalAudioActive = false;
            });
        }
    } else {
        // If no button provided (direct API call), just play/pause without UI updates
        if (currentAudio && currentAudio.src.endsWith(audioPath)) {
            if (!currentAudio.paused) {
                currentAudio.pause();
                document.getElementById('global-audio-toggle').innerHTML = '<i class="fa fa-play"></i>';
            } else {
                currentAudio.play();
                document.getElementById('global-audio-toggle').innerHTML = '<i class="fa fa-pause"></i>';
            }
        } else {
            if (currentAudio) {
                currentAudio.pause();
                currentAudio.currentTime = 0;
            }
            
            currentAudio = new Audio(audioPath);
            document.getElementById('global-audio-title').textContent = title || 'Playing audio...';
            document.getElementById('global-audio-container').style.display = 'block';
            
            currentAudio.play()
                .then(() => {
                    document.getElementById('global-audio-toggle').innerHTML = '<i class="fa fa-pause"></i>';
                    globalAudioActive = true;
                });
                
            currentAudio.addEventListener('ended', () => {
                document.getElementById('global-audio-container').style.display = 'none';
                globalAudioActive = false;
            });
        }
    }
}

// Call this to stop any playing audio when navigating away
export function stopAllAudio() {
    if (currentAudio) {
        currentAudio.pause();
        currentAudio.currentTime = 0;
        currentAudio = null;
    }
    
    if (currentButton) {
        currentButton.innerHTML = '<i class="fa fa-play"></i>';
        currentButton.classList.remove('playing');
        currentButton = null;
    }
    
    // Hide the global audio player
    const container = document.getElementById('global-audio-container');
    if (container) {
        container.style.display = 'none';
    }
    
    globalAudioActive = false;
}

// Export a function to check if audio is playing
export function isAudioPlaying() {
    return globalAudioActive;
}


